import { TextColorNames } from "@smartsuite/react-ui";
import styled from "styled-components";

export const Wrapper = styled.div`
  margin: 20px 30px 20px 30px;
`;

export const Info = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 18px;
  color: ${TextColorNames.tertiary};
`;

export const Label = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 18px;
  margin-bottom: 10px;
`;

export const Space = styled.div`
  margin-top: 20px;
`;

export const CheckboxView = styled.div`
  display: flex;
  .checkbox-rect {
    width: 30px;
  }
`;

export const CheckboxText = styled.div`
  display: inline;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  cursor: pointer;
`;

export const CancelWrapper = styled.div`
  margin-right: 10px;
`;
